module.exports = __webpack_public_path__ + "images/duin-4d0bcc8ee68133d6f1171ce043d02da7.jpg";